import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parent_activitiesData: any;
  parent_activitiesLoading: boolean;
  parent_activitiesError: SerializedError | null;
  page: number;
} = {
  parent_activitiesData: {},
  parent_activitiesLoading: false,
  parent_activitiesError: null,
  page: 1,
};

export const parent_activitiesFunc = createAsyncThunk(
  'parent_activities/parent_activitiesFunc',
  async (values: {
    fee: number | null;
    category: string | null;
    fromQuota: number | null;
    toQuota: number | null;
    byCoordinates: boolean | null;
    long: number | null;
    lat: number | null;
    finished: boolean | null;
    page: number | null;
    pageSize: number | null;
    listing: {
      title: string | null;
      ageInterval: number[] | null;
      format: string | null;
    };
    location: {
      district: string | null;
      city: string | null;
      parking: string | null;
    };
    schedule: {
      days: string[] | null;
      dateInterval: {
        from: string | null;
        to: string | null;
      };
    };
    price: {
      from: number | null;
      to: number | null;
    };
    //TODO @mfurkankayikci typeları hızlıca ekledim, içlerinde yanlış olanlar mutlaka vardır. kontrol edersin
  }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `query Parent_activities($filter: FilterActivityByParentInput, $pagination: Pagination) {
      parent_activities(filter: $filter, pagination: $pagination) {
        count
        data {
          _id
          additionalDetails
          createdAt
          duration
          fee
          hoursBeforeReservationExpires
        externalLink
        externalMail
        externalPhoneNumber
          isReservationRequired
          likedByParent
          listing {
            _id
            ageInterval
            category
            companionship
            coverImage
            description
            exteriorOrganizer {
              _id
              name
              imageUrl
              details
              createdAt
              updatedAt
              socialMedia {
                website
                instagram
                twitter
                facebook
                youtube
              }
            }
            format
            images
            rating {
              average
              numberOfReviews
              createdAt
              updatedAt
            }
            subCategory
            title
          }
          location {
            _id
            city
            district
            country
            address {
              description
              title
            }
            lat
            long
            parking
          }
          price
          quota
          schedule {
            _id
            createdAt
            days {
              _id
              activity {
                _id
              }
              date
              day
              startTime
              endTime
              createdAt
              updatedAt
            }
            endDate
            repeatedIntervalType
            startDate
            totalDayCount
            updatedAt
          }
          status
          updatedAt
          updatedBy {
            _id
            displayName
            displayImageUrl
            description
            role 
          }
          title
          participantCount
          createdBy {
            _id
            displayName
            displayImageUrl
            description
            role
          }
        }
      }
    }`,
      variables: {
        filter: {
          additionalDetails: null,
          duration: {
            from: null,
            to: null,
          },
          fee: values?.fee ?? null,
          listing: {
            ageInterval: values?.listing?.ageInterval ?? null,
            category: values?.category ?? null,
            companionship: null,
            description: null,
            format: values?.listing?.format ?? null,
            title: values?.listing?.title ?? null,
          },
          price: {
            from: values?.price?.from ?? null,
            to: values?.price?.to ?? null,
          },
          quota: {
            from: values?.fromQuota ?? null,
            to: values?.toQuota ?? null,
          },
          location: {
            city: values?.location?.city ?? null,
            district: values?.location?.district ?? null,
            parking: values?.location?.parking ?? null,
            byCoordinates:
              values?.byCoordinates === false
                ? null
                : {
                    radius:null,
                    long: values?.long ?? null,
                    lat: values?.lat ?? null,
                  },
          },
          schedule: {
            finished: false,
            days: values?.schedule?.days ?? null,
            dateInterval: {
              from: values?.schedule?.dateInterval?.from ?? null,
              to: values?.schedule?.dateInterval?.to ?? null,
            },
          },
        },
        pagination: {
          page: values.page,
          pageSize: values.pageSize,
        },
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parent_activities = createSlice({
  name: 'parent_activities',
  initialState,
  reducers: {
    setPaginationParent: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parent_activitiesFunc.pending, (state) => {
      state.parent_activitiesLoading = true;
    });
    builder.addCase(parent_activitiesFunc.fulfilled, (state, action) => {
      state.parent_activitiesLoading = false;
      state.parent_activitiesData = action.payload?.data?.parent_activities;
      state.parent_activitiesError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parent_activitiesFunc.rejected, (state, action) => {
      state.parent_activitiesLoading = false;
      state.parent_activitiesError = action.error;
    });
  },
});

export const { setPaginationParent } = parent_activities.actions;
export default parent_activities.reducer;
